<template>
    <div v-if="dmsConfigData.dmsItems.length != 0">
        <v-card >
            <v-toolbar color="info" height="40" >
                <v-toolbar-title>
                    Configurator GETCLEAN DMS
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon color="primary" @click.prevent="closeDmsEdit()">
                    <v-icon>clear</v-icon>
                </v-btn>
            </v-toolbar>
            <v-card-text>

                <v-form ref="dmsConfigForm" v-model="dmsConfigFormValid" lazy-validation>
                    <v-layout column>
                        <!-- Section 1: Basic Questions -->
                        <v-flex>
                        <!-- <h2>Basic Questions</h2> -->
                        <v-card>
                            <v-toolbar color="info" height="40" class="lighten-3">
                                <v-toolbar-title>
                                    Basic Questions
                                </v-toolbar-title>
                                <v-spacer></v-spacer>
                                <!-- <v-btn icon color="primary" @click.prevent="closeDmsEdit()">
                                    <v-icon>clear</v-icon>
                                </v-btn> -->
                            </v-toolbar>
                            <v-card-text>
                            <v-layout column>
                                <!-- <v-flex class="">
                                    <v-layout row align-center>
                                        <v-flex xs1>
                                        <div class="question-order">1</div>
                                        </v-flex>
                                        <v-flex xs9>
                                        <div class="question-text">
                                            <strong>Distance from equipment to Detergent room (Longest run (Ft))</strong>
                                            <div class="question-info">Fill in the distance from the machine furthest away to the detergent room (max 300 Ft)</div>
                                        </div>
                                        </v-flex>
                                        <v-flex xs2>
                                            <v-text-field 
                                                :rules="[rules.required, (v) => rules.maxValueRule(v, 300)]"
                                                v-model="dmsConfigData.distanceEquipToRoom.value" 
                                                type="number"
                                                label=""
                                                hint=""
                                                box
                                            ></v-text-field>
                                        </v-flex>
                                    </v-layout>
                                </v-flex> -->
                                <v-flex class="">
                                    <v-layout row align-center>
                                        <v-flex xs1>
                                        <div class="question-order">1</div>
                                        </v-flex>
                                        <v-flex xs9>
                                        <div class="question-text">
                                            <strong>Distance from equipment to Detergent room (Longest run Ft)</strong>
                                            <div class="question-info">Select the distance from the DMS room to the most remote piece of equipment (max 250 Ft)</div>
                                        </div>
                                        </v-flex>
                                        <v-flex xs3>
                                            <v-select 
                                            :rules="[rules.required]"
                                            v-model="dmsConfigData.distanceEquipToRoom.value"
                                            :items="dmsConfigData.distanceEquipToRoom.selections" 
                                            item-text="name" 
                                            item-value="id" 
                                            label=""
                                            hint=""
                                            
                                            box
                                            ></v-select>
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                                <v-flex class="" v-show="currentStep>1">
                                    <v-layout row align-center>
                                        <v-flex xs1>
                                            <div class="question-order">2</div>
                                        </v-flex>
                                        <v-flex xs9>
                                        <div class="question-text">
                                            <strong>Number of Wands needed for Supply Containers</strong>
                                            <div class="question-info">How many different detergents will be used at the facility</div>
                                        </div>
                                        </v-flex>
                                        <v-flex xs2>

                                            <v-text-field 
                                                :rules="[rules.required, (v) => rules.maxValueRule(v, 11)]"
                                                v-model="dmsConfigData.detergentContainerQty.value" 
                                                type="number"
                                                label=""
                                                hint=""
                                                box
                                                @focus="selectAllText"
                                            ></v-text-field>
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                                <v-flex class="" v-show="currentStep>2">
                                    <v-layout row align-center>
                                        <v-flex xs1>
                                            <div class="question-order">3</div>
                                        </v-flex>
                                        <v-flex xs8>
                                        <div class="question-text">
                                            <strong>Detergent Supply Container Size</strong>
                                            <div class="question-info">Select the supply container size used in the detergent room</div>
                                        </div>
                                        </v-flex>
                                        <v-flex xs3>
                                            <v-select 
                                            :rules="[rules.required]"
                                            v-model="dmsConfigData.containerSize.value"
                                            :items="dmsConfigData.containerSize.selections" 
                                            item-text="name" 
                                            item-value="id" 
                                            label=""
                                            hint=""
                                            
                                            box
                                            ></v-select>
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                                <v-flex class="" v-show="currentStep>3">
                                    <v-layout row align-center>
                                        <v-flex xs1>
                                            <div class="question-order">4</div>
                                        </v-flex>
                                        <v-flex xs8>
                                        <div class="question-text">
                                            <strong>Size of Installation Job</strong>
                                            <div class="question-info"></div>
                                        </div>
                                        </v-flex>
                                        <v-flex xs3>
                                            <v-select 
                                            :rules="[rules.required]"
                                            v-model="dmsConfigData.jobSize.value"
                                            :items="dmsConfigData.jobSize.selections" 
                                            item-text="name" 
                                            item-value="id" 
                                            label=""
                                            hint=""
                                            
                                            box
                                            ></v-select>
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                                <v-flex class="" v-show="currentStep>4">
                                    <v-layout row align-center>
                                        <v-flex xs1>
                                            <div class="question-order">5</div>
                                        </v-flex>
                                        <v-flex xs8>
                                        <div class="question-text">
                                            <strong>Preventative Maintenance for Length of Agreement Term</strong>
                                            <div class="question-info">Select the appropriate 1YR – 5 YR Provision Of Service term 
                                                (typically - PRM DMS SYS POS Y3)</div>
                                        </div>
                                        </v-flex>
                                        <v-flex xs3>
                                            <v-select 
                                            :rules="[rules.required]"
                                            v-model="dmsConfigData.pmContract.value"
                                            :items="dmsConfigData.pmContract.selections" 
                                            item-text="name" 
                                            item-value="id" 
                                            label=""
                                            hint=""
                                            
                                            box
                                            ></v-select>
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                                <v-flex xs12 pl-1 >

                                </v-flex>
                            </v-layout>
                            </v-card-text>
                        </v-card>
                        </v-flex>
                
                        <!-- Section 2: Equipment -->
                        <v-flex class="mt-4">
                        <!-- <h2>Equipment</h2> -->
                        <v-card>
                            <v-toolbar color="info" height="40" class="lighten-3">
                                <v-toolbar-title>
                                    Equipment
                                </v-toolbar-title>
                                <v-spacer></v-spacer>
                            </v-toolbar>
                            <v-card-text>
                            <v-layout column v-show="currentStep>5">
                                <v-flex class="">
                                    <v-layout row align-center>
                                        <v-flex xs1>
                                        <div class="question-order">6</div>
                                        </v-flex>
                                        <v-flex xs9>
                                        <div class="question-text">
                                            <strong>Washer Disinfectors</strong>
                                            <div class="question-info">How many washer disinfectors? (3 detergents/washer)</div>
                                        </div>
                                        </v-flex>
                                        <v-flex xs2>
                                            <v-text-field 
                                                :rules="[(v) => rules.maxValueRule(v, 11)]"
                                                v-model="dmsConfigData.disinfectorsQty.value" 
                                                type="number"
                                                label=""
                                                hint=""
                                                @input="recalculateAllItems"
                                                box
                                            ></v-text-field>
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                                <v-flex class="">
                                    <v-layout row align-center>
                                        <v-flex xs1>
                                        <div class="question-order">7</div>
                                        </v-flex>
                                        <v-flex xs9>
                                        <div class="question-text">
                                            <strong>Cart Washer with Instrument Cycle </strong>
                                            <div class="question-info">How many cart washers with instrument cycle? (4 detergents/CW)</div>
                                        </div>
                                        </v-flex>
                                        <v-flex xs2>
                                            <v-text-field 
                                                :rules="[(v) => rules.maxValueRule(v, 11)]"
                                                v-model="dmsConfigData.cartWashersWithCycleQty.value" 
                                                type="number"
                                                label=""
                                                hint=""
                                                @input="recalculateAllItems"
                                                @focus="selectAllText"
                                                box
                                            ></v-text-field>
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                                <v-flex class="">
                                    <v-layout row align-center>
                                        <v-flex xs1>
                                        <div class="question-order">8</div>
                                        </v-flex>
                                        <v-flex xs9>
                                        <div class="question-text">
                                            <strong>Cart Washer without Instrument Cycle </strong>
                                            <div class="question-info">How many cart washers without instrument cycle? (2 detergents/CW)</div>
                                        </div>
                                        </v-flex>
                                        <v-flex xs2>
                                            <v-text-field 
                                                :rules="[(v) => rules.maxValueRule(v, 11)]"
                                                v-model="dmsConfigData.cartWashersWithoutCycleQty.value" 
                                                type="number"
                                                label=""
                                                hint=""
                                                @input="recalculateAllItems"
                                                @focus="selectAllText"
                                                box
                                            ></v-text-field>
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                                <v-flex class="">
                                    <v-layout row align-center>
                                        <v-flex xs1>
                                        <div class="question-order">9</div>
                                        </v-flex>
                                        <v-flex xs9>
                                        <div class="question-text">
                                            <strong>2460 Sonics Only</strong>
                                            <div class="question-info">How many 2460 ultrasonic cleaners? (1 detergents/Sonic)</div>
                                        </div>
                                        </v-flex>
                                        <v-flex xs2>
                                            <v-text-field 
                                                :rules="[(v) => rules.maxValueRule(v, 11)]"
                                                v-model="dmsConfigData.sonic2460Qty.value" 
                                                type="number"
                                                label=""
                                                hint=""
                                                @input="recalculateAllItems"
                                                @focus="selectAllText"
                                                box
                                            ></v-text-field>
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                                <v-flex class="">
                                    <v-layout row align-center>
                                        <v-flex xs1>
                                        <div class="question-order">10</div>
                                        </v-flex>
                                        <v-flex xs9>
                                        <div class="question-text">
                                            <strong>Ultrasonics Cleaner (All Others)</strong>
                                            <div class="question-info">How many ultrasonic cleaners? (1 detergents/Sonic) </div>
                                        </div>
                                        </v-flex>
                                        <v-flex xs2>
                                            <v-text-field 
                                                :rules="[(v) => rules.maxValueRule(v, 11)]"
                                                v-model="dmsConfigData.cleanerQty.value" 
                                                type="number"
                                                label=""
                                                hint=""
                                                @input="recalculateAllItems"
                                                @focus="selectAllText"
                                                box
                                            ></v-text-field>
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                                <v-flex class="">
                                    <v-layout row align-center>
                                        <v-flex xs1>
                                        <div class="question-order">11</div>
                                        </v-flex>
                                        <v-flex xs9>
                                        <div class="question-text">
                                            <strong>Sink Units (1 sink per pump system)</strong>
                                            <div class="question-info">How many sink units? (1 detergents/sink) </div>
                                        </div>
                                        </v-flex>
                                        <v-flex xs2>
                                            <v-text-field 
                                                :rules="[(v) => rules.maxValueRule(v, 11)]"
                                                v-model="dmsConfigData.sinkFreeStandingQty.value" 
                                                type="number"
                                                label=""
                                                hint=""
                                                @input="recalculateAllItems"
                                                @focus="selectAllText"
                                                box
                                            ></v-text-field>
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                                <!-- <v-flex class="">
                                    <v-layout row align-center>
                                        <v-flex xs1>
                                        <div class="question-order">10</div>
                                        </v-flex>
                                        <v-flex xs9>
                                        <div class="question-text">
                                            <strong>Sink units back to back (2 sinks share pump system)</strong>
                                            <div class="question-info">How many sink units  1 detergents/sink (2 sink/pump)</div>
                                        </div>
                                        </v-flex>
                                        <v-flex xs2>
                                            <v-select 
                                                :rules="[]"
                                                v-model="dmsConfigData.sinkBackToBackQty.value"
                                                :items="dmsConfigData.sinkBackToBackQty.selections" 
                                                label=""
                                                hint=""
                                                @input="recalculateAllItems"
                                                box
                                            ></v-select>
                                        </v-flex>
                                    </v-layout>
                                </v-flex> -->
                                <v-flex color="info">
                                    <v-layout row align-center>
                                        <v-flex xs6>
                                        <div class="question-order"></div>
                                        </v-flex>
                                        <v-flex xs4>
                                            <div class="question-text">
                                                <strong>Total Count (Required)</strong>
                                                <div class="question-info"></div>
                                            </div>
                                        </v-flex>
                                        <v-flex xs2>
                                            <strong>{{ totalConfigEquipmentCount }}</strong>
                                            
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                            </v-layout>
                            </v-card-text>
                        </v-card>
                        </v-flex>
                
                        <!-- Section 3: Item List -->
                        <v-flex class="mt-4">
                            <h2 class="pl-3"></h2>
                            <v-card>
                                <v-toolbar color="info" height="40" class="lighten-2">
                                    <v-toolbar-title>
                                        Review Items To Quote
                                    </v-toolbar-title>
                                    <v-spacer></v-spacer>
                                    <!-- <v-btn icon color="primary" @click.prevent="closeDmsEdit()">
                                        <v-icon>clear</v-icon>
                                    </v-btn> -->
                                </v-toolbar>
                                <v-card-text>
                                    <v-layout row>
                                        <v-spacer></v-spacer>
                                        <v-chip 
                                            small
                                            :color="showQuotedItemsOnly?'green' : ''" 
                                            @click="showQuotedItemsOnly=!showQuotedItemsOnly">                                        
                                            <v-avatar v-show="showQuotedItemsOnly">                      
                                                <v-icon>check_circle_outline</v-icon>
                                            </v-avatar>
                                            <v-avatar v-show="!showQuotedItemsOnly">                                          
                                                <v-icon>radio_button_unchecked</v-icon>
                                            </v-avatar>
                                            Quoted Items Only
                                        </v-chip>
                                        <!-- <v-flex body-2>
    
                                        </v-flex> -->
                                        <v-spacer></v-spacer>
                                    </v-layout>
                                    <v-data-table
                                        :headers="headers"
                                        :items="calculatedItems"
                                        class="elevation-1 mt-4 condensed-datatable"
                                        :dense="true"
                                        hide-actions
                                        >
                                        <template slot="items" slot-scope="props">
                                            <td>{{ props.item.catalogNum }}</td>
                                            <td>{{ props.item.name }}</td>
                                            <td class="text-xs-center"><strong>{{ props.item.configQty }}</strong></td>
                                            <td class="text-xs-center">
                                                <v-text-field 
                                                    :rules="[(v) => rules.maxValueRule(v, 20)]"
                                                    v-model="props.item.extraQty" 
                                                    type="number"
                                                    label=""
                                                    hint=""
                                                    @input="calculateItemPriceAfterQtyChanged(props.item)"
                                                    @focus="selectAllText"
                                                    class="text-xs-center"
                                                    dense
                                                    style="font-size: 0.875rem; width: 50px;"
                                                ></v-text-field>
                                            </td>
                                            <td class="text-xs-center">
                                                <template v-if="props.item.priceLoading">
                                                    <v-progress-circular indeterminate :size="16" :width="2" color="primary"></v-progress-circular>
                                                </template>
                                                <template v-else>
                                                    {{ formatCurrency(props.item.unitPrice, null) }}
                                                    <br>
                                                    <span v-if="props.item.priceSource || !props.item.itemNo" :style="priceSourceStyle(props.item.priceSource)">
                                                        ({{ props.item.priceSource || 'Hardcoded' }})
                                                    </span>
                                                </template>
                                            </td>
                                            <td class="text-xs-center">{{ formatCurrency(props.item.subTotal, null) }}</td>
                                        </template>
                                        <template slot="footer">
                                            <tr>
                                                <td colspan="5" class="text-xs-right"><strong>Total Amount</strong></td>
                                                <td>{{ formatCurrency(sumItemsTotalPrice, null) }}</td>

                                            </tr>
                                        </template>
                                    </v-data-table>
                                    <v-layout>
                                        <v-flex xs-12 pt-3 class="text-xs-center">
                                            <v-btn color="primary" :disabled="!dmsConfigFormValid" 
                                                @click="onSaveItem">Add DMS Items To Quote</v-btn>
                                            <!-- <v-btn @click="clear">clear</v-btn> -->
                                        </v-flex>
                                    </v-layout>
                                </v-card-text>
                            </v-card>
                        </v-flex>
                    </v-layout>
    
                </v-form>
            </v-card-text>
            <v-card-text>


            </v-card-text>
            <!-- {{ currentStep }} -->
<!-- {{ dmsConfigData }} -->
<!-- {{ dmsItems }} -->
        </v-card>

    </div>

  </template>
  
  <script>
  import { mapGetters, mapActions } from "vuex";

  export default {
    props: ['quoteId', 'facilityPriceLevel'],
    data() {
      return {
        dmsConfigFormValid: false,
        nextStep: 0,
        currentStep: 1,
        showQuotedItemsOnly: true,
        dmsConfigData: {
                distanceEquipToRoom: {
                    value: null,
                    // maxValue: 300,
                    // unit: 'Ft',
                    required: true,
                    selections: [
                        {orderNum: 1, id: '50', name: '50 ft.'},
                        {orderNum: 2, id: '100', name: '100 ft.'},
                        {orderNum: 3, id: '250', name: '250 ft.'}
                    ]
                },
                detergentContainerQty: {
                    value: null,
                    required: true,

                },
                containerSize: {
                    value: null,
                    required: true,
                    selections: [
                        {orderNum: 1, id: '6003001310', name: '5 Gallon'},
                        {orderNum: 2, id: '6003001311', name: '15 Gallon'},
                        {orderNum: 3, id: '6003001312', name: '30+ Gallon'}
                    ]
                },
                jobSize: {
                    value: null,
                    required: true,
                    selections: [
                        {orderNum: 1, id: 'ZSUSINSTAL-DMS-SM', name: 'Small - 9 pumps or less'},
                        {orderNum: 2, id: 'ZSUSINSTAL-DMS-MED', name: 'Medium - 10 to 17 pumps'},
                        {orderNum: 3, id: 'ZSUSINSTAL-DMS-LRG', name: 'Large - 18 or more pumps'}
                    ]
                },
                pmContract: {
                    value: null,
                    required: true,
                    selections: [
                        {orderNum: 1, id: 'ZSUSPOSPMDMSSYS1Y', name: 'PRM DMS System POS Y1'},
                        {orderNum: 2, id: 'ZSUSPOSPMDMSSYS2Y', name: 'PRM DMS System POS Y2'},
                        {orderNum: 3, id: 'ZSUSPOSPMDMSSYS3Y', name: 'PRM DMS System POS Y3'},
                        {orderNum: 4, id: 'ZSUSPOSPMDMSSYS4Y', name: 'PRM DMS System POS Y4'},
                        {orderNum: 5, id: 'ZSUSPOSPMDMSSYS5Y', name: 'PRM DMS System POS Y5'}
                    ]
                },
                disinfectorsQty: {
                    value: null,
                    // maxValue: 11,
                    unit: 'each',
                    // required: true,
                },
                cartWashersWithCycleQty: {
                    value: null,
                    // maxValue: 11,
                    unit: 'each',
                    // required: true,
                },
                cartWashersWithoutCycleQty: {
                    value: null,
                    // maxValue: 11,
                    unit: 'each',
                    // required: true,
                },
                sonic2460Qty: {
                    value: null,
                    // maxValue: 11,
                    unit: 'each',
                    // required: true,
                },
                cleanerQty: {
                    value: null,
                    // maxValue: 11,
                    unit: 'each',
                    // required: true,
                },
                sinkFreeStandingQty: {
                    value: null,
                    // maxValue: 11,
                    unit: 'each',
                    // required: true,
                },
                sinkBackToBackQty: {
                    value: null,
                    // maxValue: 11,
                    unit: 'each',
                    selections: [2,4,6,8,10]
                },
                dmsItems: [],

            },
            headers: [
                { text: 'Catalog #', value: 'catalogNum', width: '20%' },
                { text: 'Description', value: 'name' },
                { text: 'Config Qty', value: 'configQty', width: '12%' },
                { text: 'Extra Qty', value: 'extraQty', width: '12%' },
                { text: 'Rate', value: 'unitPrice', width: '12%' },
                { text: 'Total', value: 'subTotal', width: '12%' }
            ],
        
            rules: {
                required: v => !!v || "This field is required",
                maxValueRule: (v, max) => (v <= max) || `Maximum value is ${max}`
            },
      };
    },
    computed: {
        calculatedItems() {
            const useFilter = true; // You can set this to false to disable filtering

            if (this.showQuotedItemsOnly) {
                return this.dmsConfigData.dmsItems
                    .filter(item => (item.configQty > 0 || item.extraQty > 0) && item.active);
            } else {
                return this.dmsConfigData.dmsItems.filter(item => item.active);
            }
        },
        totalConfigEquipmentCount() {
            if(this.dmsConfigData) {
                return (Number(this.dmsConfigData.disinfectorsQty.value) || 0)
                        + (Number(this.dmsConfigData.cartWashersWithCycleQty.value) || 0)
                        + (Number(this.dmsConfigData.cartWashersWithoutCycleQty.value) || 0)
                        + (Number(this.dmsConfigData.sonic2460Qty.value) || 0)
                        + (Number(this.dmsConfigData.cleanerQty.value) || 0)
                        + (Number(this.dmsConfigData.sinkFreeStandingQty.value) || 0)
                        + (Number(this.dmsConfigData.sinkBackToBackQty.value) || 0)
            } else {
                return 0
            }
        },
        sumItemsTotalPrice() {
            if(this.dmsConfigData && this.dmsConfigData.dmsItems) {
                return this.dmsConfigData.dmsItems.reduce((sum, item) => sum + (Number(item.subTotal) || 0), 0);
            } else {
                return 0
            }
        },
        distinceFactor() {
            let result = (Number(this.dmsConfigData.distanceEquipToRoom.value) || 0) / 200;

            // Round to 2 decimal places
            result = Math.round(result * 100) / 100;

            return result;
        }
    },
    methods: {
        ...mapActions('pubQuoteEdit', [
            'getDmsConfiguratorItems',
            'saveDmsItemsToQuote',
            'getDmsItemPrice',
        ]),
        ...mapActions('itemSearch',[
            'searchItemPrices'
        ]),
        priceSourceStyle(priceSource) {
            switch (priceSource) {
                case 'GShapeAPI': return { color: 'green', fontWeight: 'bold', fontSize: '0.75rem' };
                case 'ListPrice': return { color: 'blue', fontWeight: 'bold', fontSize: '0.75rem' };
                case 'API No Price': return { color: 'orange', fontWeight: 'bold', fontSize: '0.75rem' };
                case 'API Error': return { color: 'red', fontWeight: 'bold', fontSize: '0.75rem' };
                default: return { color: 'grey', fontSize: '0.75rem' };  // Hardcoded
            }
        },
        async getDmsItems () {
            // console.log(`quoteId:${this.quoteId}` )
            this.dmsConfigData.dmsItems = await this.getDmsConfiguratorItems(this.quoteId)
        },
        // formatCurrency(value) {
        //     return value? `$${value.toFixed(2)}` : ''
        // },
        selectAllText(event) {
            event.target.select();
        },
        // updateItemQtyByitemNo(itemNo, newQty) {
        //     // Find the item with the matching id
        //     const item = this.dmsConfigData.dmsItems.find(item => item.itemNo === itemNo);
            
        //     // If item exists, update the quantity
        //     if (item) {
        //         item.qty = newQty;
        //         console.log(`Updated ${item.name} with new quantity: ${newQty}`);
        //     } else {
        //         alert(`Item with No ${itemNo} not found.`);
        //     }
        // },
        recalculateAllItems() {
            this.dmsConfigData.dmsItems.forEach(itm => this.calculateQuantity(itm))
        },
        calculateQuantity(item) {
            let controllerQty6003001300 = (Number(this.dmsConfigData.cartWashersWithCycleQty.value) || 0)
                        + (Number(this.dmsConfigData.sonic2460Qty.value) || 0) 
                        + (Number(this.dmsConfigData.cleanerQty.value) || 0) 
                        + (Number(this.dmsConfigData.sinkFreeStandingQty.value) || 0) 

            let controllerQty6003001302 = (Number(this.dmsConfigData.disinfectorsQty.value) || 0)
                        + (Number(this.dmsConfigData.cartWashersWithCycleQty.value) || 0)
                        + (Number(this.dmsConfigData.cartWashersWithoutCycleQty.value) || 0)

            switch (item.catalogNum) {
                case "6003001000": // CSD Dose Tech w/ Flow Meter
                    //added per Michael: The Dose Tech Pump w/ Flow Meter will need to populate when a “Sink” is selected in the equipment list
                    item.configQty = (Number(this.dmsConfigData.sinkFreeStandingQty.value) || 0) 
                    break
                // case "6003001301": // Controller GET Clean 2Pump115V
                    //=(E17*2)+E18+(ROUNDUP(E21/2,0))
                case "6003001300": // Controller GET Clean 1Pump115V
                    //=E19+E20
                    // console.log("6003001300 this.dmsConfigData.cleanerQty.value" + this.dmsConfigData.cleanerQty.value)
                    item.configQty = controllerQty6003001300
                        // (Number(this.dmsConfigData.cartWashersWithCycleQty.value) || 0)
                        // + (Number(this.dmsConfigData.sonic2460Qty.value) || 0) 
                        // + (Number(this.dmsConfigData.cleanerQty.value) || 0) 
                        // + (Number(this.dmsConfigData.sinkFreeStandingQty.value) || 0) 
                    // this.updateItemTotals(item)
                    break
                // case "6003001301": // Controller GET Clean 2Pump115V
                    //=(E17*2)+E18+(ROUNDUP(E21/2,0))
                case "6003001302": // Controller GET Clean 3Pump115V
                    // console.log("this.dmsConfigData.disinfectorsQty.value" + this.dmsConfigData.disinfectorsQty.value)
                    item.configQty = controllerQty6003001302
                        // (Number(this.dmsConfigData.disinfectorsQty.value) || 0)
                        // + (Number(this.dmsConfigData.cartWashersWithCycleQty.value) || 0)
                        // + (Number(this.dmsConfigData.cartWashersWithoutCycleQty.value) || 0)

                    // this.updateItemTotals(item)
                    break
                // return numberOfWashersDryers >= 3 ? Math.ceil(numberOfWashersDryers / 3) : 0;
                case "6003001306": // Tank Reservoir 1 Gal with SIB
                    //=E16+E19+E20+ROUNDUP((E21/2),0)
                    // item.configQty = this.dmsConfigData.disinfectorsQty.value + this.dmsConfigData.cleanerQty.value + this.dmsConfigData.sinkFreeStandingQty.value + Math.ceil(this.dmsConfigData.sinkBackToBackQty.value / 2);
                    item.configQty = (Number(this.dmsConfigData.disinfectorsQty.value) || 0)
                        + (Number(this.dmsConfigData.sonic2460Qty.value) || 0)


                        + Math.ceil((Number(this.dmsConfigData.sinkBackToBackQty.value) || 0) / 2)
                    // this.updateItemTotals(item)
                    break
                case "6003001307": // Tank Reservoir 1Gal withoutSIB
                    //=E16*2+(ROUNDUP(E21/2,0))
                    let qty6003001307 = (Number(this.dmsConfigData.disinfectorsQty.value) || 0) * 2
                    + Math.ceil((Number(this.dmsConfigData.sinkBackToBackQty.value) || 0) / 2)
                    if (qty6003001307 != item.configQty) {
                        item.configQty = qty6003001307
                    }
                    break

                case "6003001308": // Tank Reservoir 2 Gal with SIB
                    //=(E17*2)+E18
                    item.configQty = (Number(this.dmsConfigData.cartWashersWithCycleQty.value) || 0) * 2
                        + (Number(this.dmsConfigData.cartWashersWithoutCycleQty.value) || 0)
                        + (Number(this.dmsConfigData.cleanerQty.value) || 0)
                        + (Number(this.dmsConfigData.sinkFreeStandingQty.value) || 0)
                    break

                case "6003001309": // Tank Reservoir 2Gal withoutSIB
                    //=(E17*2)+E18
                    item.configQty = (Number(this.dmsConfigData.cartWashersWithCycleQty.value) || 0) * 2
                        + (Number(this.dmsConfigData.cartWashersWithoutCycleQty.value) || 0) * 2
                    break
                case "6003001310": // Level Sensor 5-10 Galons
                    //=IF(E13="5-10 Galons",E12+E28,0)
                    // console.log("6003001310: " + this.dmsConfigData.detergentContainerQty.value)
                    if (this.dmsConfigData.containerSize.value == "6003001310") {
                        item.configQty = (Number(this.dmsConfigData.detergentContainerQty.value) || 0)
                    } else {
                        item.configQty = 0
                    }
                    break
                case "6003001311": // Level Sensor 10-30 Galons
                    //=IF(E13="10-30 Galons",E12+E28,0)
                    console.log("6003001311: " + this.dmsConfigData.detergentContainerQty.value)
                    if (this.dmsConfigData.containerSize.value == "6003001311") {
                        item.configQty = (Number(this.dmsConfigData.detergentContainerQty.value) || 0)
                    } else {
                        item.configQty = 0
                    }
                    break
                case "6003001312": // Level Sensor 30-55 Galons
                    //=IF(E13="30-55 Galons",E12+E28,0)
                    if (this.dmsConfigData.containerSize.value == "6003001312") {
                        item.configQty = (Number(this.dmsConfigData.detergentContainerQty.value) || 0)
                    } else {
                        item.configQty = 0
                    }
                    break
                case "6003001313": // Communication Cable 50 FT
                    //=(IF(E11<50,(E22+E17-E21+(ROUNDUP(E21/2,0))),0)+E29)
                    if (this.dmsConfigData.distanceEquipToRoom.value == 50) {
                        item.configQty = this.totalConfigEquipmentCount
                            + (Number(this.dmsConfigData.cartWashersWithCycleQty.value) || 0)
                            - (Number(this.dmsConfigData.sinkBackToBackQty.value) || 0)
                            + Math.ceil((Number(this.dmsConfigData.sinkBackToBackQty.value) || 0) / 2)
                    } else {
                        item.configQty = 0
                    }
                    break

                case "6003001314": // Communication Cable 100 FT
                    // =(IF(AND(E11>=MIN(50),E11<=MAX(99)),(E22+E17-E21+(ROUNDUP(E21/2,0))), 0)+E30)    
                    if (this.dmsConfigData.distanceEquipToRoom.value == 100) {
                            item.configQty = this.totalConfigEquipmentCount
                            + (Number(this.dmsConfigData.cartWashersWithCycleQty.value) || 0)
                            - (Number(this.dmsConfigData.sinkBackToBackQty.value) || 0)
                            + Math.ceil((Number(this.dmsConfigData.sinkBackToBackQty.value) || 0) / 2)
                    } else {
                        item.configQty = 0
                    }
                    break
                case "6003001315": // Communication Cable 250 FT
                    //=(IF(E11>99,(E22+E17-E21+(ROUNDUP(E21/2,0))),0)+E31)
                    if (this.dmsConfigData.distanceEquipToRoom.value == 250) {
                            item.configQty = this.totalConfigEquipmentCount
                            + (Number(this.dmsConfigData.cartWashersWithCycleQty.value) || 0)
                            - (Number(this.dmsConfigData.sinkBackToBackQty.value) || 0)
                            + Math.ceil((Number(this.dmsConfigData.sinkBackToBackQty.value) || 0) / 2)
                    } else {
                        item.configQty = 0
                    }
                    break
                case "6003001316": // Plenum Rated Tubing Red 250ft
                    //=(ROUNDUP(IF(F11<0.5,((E17+E18)*0.5),((E17+E18)*ROUNDUP(F11,0))),0)+E33)
                    let resultRed;

                    if (this.distinceFactor <= 0.5) {
                        resultRed = ((Number(this.dmsConfigData.cartWashersWithCycleQty.value) || 0)
                            + (Number(this.dmsConfigData.cartWashersWithoutCycleQty.value) || 0)) 
                            * 0.5
                    } else {
                        resultRed = ((Number(this.dmsConfigData.cartWashersWithCycleQty.value) || 0)
                            + (Number(this.dmsConfigData.cartWashersWithoutCycleQty.value) || 0)) 
                            //* Math.ceil(this.distinceFactor)
                    }

                    item.configQty = Math.ceil(resultRed);
                    break
                case "6003001317": // Plenum Rated Tubing Blue 250ft
                    //=(ROUNDUP(IF(F11<0.5,((E16+E17)*0.5),((E16+E17)*ROUNDUP(F11,0))),0)+E35)
                    let resultBlue;

                    if (this.distinceFactor <= 0.5) {
                        resultBlue = ((Number(this.dmsConfigData.disinfectorsQty.value) || 0)
                            + (Number(this.dmsConfigData.cartWashersWithCycleQty.value) || 0)) 
                            * 0.5
                    } else {
                        resultBlue = ((Number(this.dmsConfigData.disinfectorsQty.value) || 0)
                            + (Number(this.dmsConfigData.cartWashersWithCycleQty.value) || 0)) 
                            //* Math.ceil(this.distinceFactor)
                    }

                    item.configQty = Math.ceil(resultBlue);
                    break                    
                case "6003001318": // Plenum Rated Tubing Green 250ft
                    //=(ROUNDUP(IF(F11<0.5,((E16+E17+E19+(ROUNDUP(E21/2,0)))*0.5),(E16+E17+E19+(ROUNDUP(E21/2,0))*ROUNDUP(F11,0))),0)+E37)
                    let resultGreen;

                    // Calculate the common part: E16 + E17 + E19 + ROUNDUP(E21/2, 0)
                    let commonPart = (Number(this.dmsConfigData.disinfectorsQty.value) || 0)
                        + (Number(this.dmsConfigData.cartWashersWithCycleQty.value) || 0)
                        + Math.ceil(this.dmsConfigData.sinkBackToBackQty.value / 2);
                    //20241216 rule: if have 3 or more equips, every 3, we need 1 green tube
                    let greenExtra = Math.floor(
                        (
                            (Number(this.dmsConfigData.sonic2460Qty.value) || 0) 
                            + (Number(this.dmsConfigData.cleanerQty.value) || 0)
                            + (Number(this.dmsConfigData.sinkFreeStandingQty.value) || 0)
                        )/3
                    )

                    if (this.distinceFactor <= 0.5) {
                        resultGreen = commonPart * 0.5 + greenExtra;
                    } else {
                        resultGreen = commonPart + greenExtra //* Math.ceil(this.distinceFactor);
                    }
// console.log(`commonPart: ${commonPart},this.distinceFactor: ${this.distinceFactor}`)
                    item.configQty = Math.ceil(resultGreen)
                    break 
                case "6003001356":    // Plenum Rated Tubing, Violet 250Ft	

                    //20241211, add one for each 
                    let resultViolet;

                    if (this.distinceFactor <= 0.5) {
                        resultViolet = ((Number(this.dmsConfigData.disinfectorsQty.value) || 0)
                            + (Number(this.dmsConfigData.cartWashersWithCycleQty.value) || 0)
                            + (Number(this.dmsConfigData.cartWashersWithoutCycleQty.value) || 0)
                        ) 
                            * 0.5
                    } else {
                        resultViolet = ((Number(this.dmsConfigData.disinfectorsQty.value) || 0)
                            + (Number(this.dmsConfigData.cartWashersWithCycleQty.value) || 0)
                            + (Number(this.dmsConfigData.cartWashersWithoutCycleQty.value) || 0)
                        ) 
                            //* Math.ceil(this.distinceFactor)
                    }

                    item.configQty = Math.ceil(resultViolet);

                    break
                case "6003001342": // total controller sum * 2
                    item.configQty = ( controllerQty6003001300 + controllerQty6003001302) * 2
                    break
                case "6003001357":
                case "6003001358":
                case "6003001359":
                    item.configQty = ( controllerQty6003001300 + controllerQty6003001302) * 3
                    break 
                case "6003001360":    // Flexelene Tubing (feet)	
                    //=(E16*10)*3
                    // item.configQty = (Number(this.dmsConfigData.disinfectorsQty.value) || 0) * 10 * 3

                    //20241211, use static number per Michael
                    item.configQty = (Number(this.dmsConfigData.detergentContainerQty.value) || 0)? 4 : 0

                    break
                // return Math.ceil((distanceEquipToRoom * numberOfWashersDryers * 2) / 250);
                case "6003001320": // SA-12 Strobe Alarm
                    // item.configQty = (Number(this.dmsConfigData.detergentContainerQty.value) || 0)

                    //20241211, use static number per Michael
                   item.configQty = (Number(this.dmsConfigData.detergentContainerQty.value) || 0)? 4 : 0
                    break
                // return 1;
                // case "6003001321": // Wire duct 2x2x6ft
                // case "6003001322": // Snap-on lid 2x6ft
                // return Math.ceil(distanceEquipToRoom / 6);
                case 'LUS-G6X4LG6':
                    // console.log("LUS-G6X4LG6: " + item.itemNo)

                    // item.configQty = !this.dmsConfigData.detergentContainerQty.value? 0 :
                    //     this.dmsConfigData.detergentContainerQty.value < 2? 2:6

                    //20241211, use static number per Michael
                    item.configQty = (Number(this.dmsConfigData.detergentContainerQty.value) || 0)? 6 : 0

                    // this.updateItemTotals(item)
                    break
                case 'LUS-C6LG6':
                    // console.log("LUS-G6X4LG6: " + item.itemNo)

                    // item.configQty = !this.dmsConfigData.detergentContainerQty.value? 0 :
                    //     this.dmsConfigData.detergentContainerQty.value < 2? 2:6

                    //20241211, use static number per Michael
                    item.configQty = (Number(this.dmsConfigData.detergentContainerQty.value) || 0)? 6 : 0
                    break
                case 'ZSUSINSTAL-DMS-SM':
                    // console.log("LUS-G6X4LG6: " + item.itemNo)

                    item.configQty = this.dmsConfigData.jobSize.value == 'ZSUSINSTAL-DMS-SM'? 1 : 0
                    // this.updateItemTotals(item)
                    break
                case 'ZSUSINSTAL-DMS-MED':
                    // console.log("LUS-G6X4LG6: " + item.itemNo)

                    item.configQty = this.dmsConfigData.jobSize.value == 'ZSUSINSTAL-DMS-MED'? 1 : 0
                    // this.updateItemTotals(item)
                    break
                case 'ZSUSINSTAL-DMS-LRG':
                    // console.log("LUS-G6X4LG6: " + item.itemNo)

                    item.configQty = this.dmsConfigData.jobSize.value == 'ZSUSINSTAL-DMS-LRG'? 1 : 0
                    // this.updateItemTotals(item)
                    break
                case 'ZSUSPOSPMDMSSYS1Y':
                    item.configQty = this.dmsConfigData.pmContract.value == 'ZSUSPOSPMDMSSYS1Y'? 1 : 0
                    break
                case 'ZSUSPOSPMDMSSYS2Y':
                    item.configQty = this.dmsConfigData.pmContract.value == 'ZSUSPOSPMDMSSYS2Y'? 1 : 0
                    break
                case 'ZSUSPOSPMDMSSYS3Y':
                    item.configQty = this.dmsConfigData.pmContract.value == 'ZSUSPOSPMDMSSYS3Y'? 1 : 0
                    break
                case 'ZSUSPOSPMDMSSYS4Y':
                    item.configQty = this.dmsConfigData.pmContract.value == 'ZSUSPOSPMDMSSYS4Y'? 1 : 0
                    break
                case 'ZSUSPOSPMDMSSYS5Y':
                    item.configQty = this.dmsConfigData.pmContract.value == 'ZSUSPOSPMDMSSYS5Y'? 1 : 0
                    break
                default:
                    break
            }
            this.calculateItemPriceAfterQtyChanged(item)
            // this.updateItemTotals(item)
        },
        calculateItemPriceAfterQtyChanged(item) {
            // Calculate sum of configQty and extraQty
            const sumQty = (Number(item.configQty) || 0)
                + (Number(item.extraQty) || 0)

            item.qty = sumQty;

            if (sumQty > 0) {
                this.fetchItemPrice(item)
            } else {
                // qty is 0, reset price fields
                item.subTotal = 0;
            }

            return item;
        },
        async fetchItemPrice(item) {
            if (!item.qty || item.qty <= 0) return;

            // Items with itemNo are GShape items - must get price from API
            // Items without itemNo use hardcoded price only
            var isGShapeItem = !!item.itemNo;

            if (!isGShapeItem) {
                // Non-GShape item: use hardcoded price
                item.priceSource = 'Hardcoded';
                item.subTotal = item.qty * item.unitPrice;
                return;
            }

            // Clear any pending debounce for this item
            if (item._priceTimer) {
                clearTimeout(item._priceTimer);
            }

            item._priceTimer = setTimeout(async () => {
                try {
                    item.priceLoading = true;
                    this.$forceUpdate();

                    const result = await this.getDmsItemPrice({
                        quoteId: this.quoteId,
                        itemNumber: item.itemNo,
                        catalogNum: item.catalogNum,
                        quantity: item.qty
                    });

                    if (result && result.isSuccess) {
                        item.unitPrice = result.unitPrice;
                        item.priceSource = result.priceSource;
                        item.subTotal = item.qty * item.unitPrice;
                    } else {
                        // GShape item: API returned no price, use 0
                        item.unitPrice = result.unitPrice || 0;
                        item.priceSource = result.priceSource || 'API No Price';
                        item.subTotal = item.qty * item.unitPrice;
                    }
                } catch (e) {
                    // GShape item: API error, show error state
                    item.priceSource = 'API Error';
                    item.subTotal = item.qty * item.unitPrice;
                } finally {
                    item.priceLoading = false;
                    this.$forceUpdate();
                }
            }, 300);  // 300ms debounce
        },
        // calculateTotal(itemNo) {
        //     const quantity = this.calculateQuantity(itemNo)
        //     let itm = this.dmsConfigData.dmsItems.find(o => o.itemNo = itemNo)
        //     return quantity * itm.pricePerPiece
        // },
        // updateCalculations() {
        // // This method is called when any input changes
        // // You can add additional logic here if needed
        // this.$forceUpdate()
        // },
        checkExtraQtyChanges(newItems, oldItems) {
            newItems.forEach((newItem, index) => {
                // console.log(`extraQty changed for item ${newItem.itemNo}: ${oldItems[index].extraQty} -> ${newItem.extraQty}`);
                if (newItem.extraQty !== oldItems[index].extraQty) {
                    // console.log(`extraQty changed for item ${newItem.itemNo}: ${oldItems[index].extraQty} -> ${newItem.extraQty}`);
                // You can perform any action here when extraQty changes
                // For example, update the total qty or subtotal
                // this.calculateQuantity(newItem);
                }
            });
        },
        updateItemTotals(item) {
            // item.qty = Number(item.configQty) + Number(item.extraQty);
            item.subTotal = item.qty * item.unitPrice;
        },
        // if dmsConfigDataToSave == null,it means we will close this popup
        async onSaveItem () {
            const itemDataToSave = {
                qteId: this.quoteId,
                dmsItems: this.dmsConfigData.dmsItems.filter(item => item.active)
            }
            // console.log('onItemPicked called')
            // console.table(itemDataToSave)
            if (this.$refs.dmsConfigForm.validate()) {

                var result = await this.saveDmsItemsToQuote(itemDataToSave);
                
                // this.$emit('onSaveItem', itemDataToSave)

                // alert('This function was not implemented yet!!!')
                //reset data for reuse next time
                // this.dmsConfigData = {}
                this.closeDmsEdit()
            }
        },
        closeDmsEdit () {
            this.nextStep = 0
            this.$emit('onSaveItem', null)
        },
        getNextStepNum () {
            this.nextStep += 1
            return this.nextStep
        }
    },
    watch: {
        originalItemData (value) {
            // if (this.isNew) {
            //     this.dmsConfigData = {}
            //     this.isCustomItem = false
            //     this.itemAllActivePromotions = []
            // } else {
            //     this.dmsConfigData = Object.assign({}, this.originalItemData)
            //     // if it has itemId, it is an HealthMark inventory item
            //     this.isCustomItem = !this.originalItemData.itemId
            //     if (!this.isCustomItem && this.originalItemData.promotions) {
            //         this.itemAllActivePromotions = this.originalItemData.promotions
            //     }

            // }

        },
        //all extra Qty change for an item will be catched here
        'dmsConfigData.dmsItems': {
            // handler(newItems, oldItems) {
            //     console.log('deep watch fired')
            //     // This function will be called whenever any property of any item changes
            //     // this.checkExtraQtyChanges(newItems, oldItems);
            //     // this.recalculateAllItems()
            //     this.checkExtraQtyChanges(newItems, oldItems)
            // },
            // deep: true
            // handler(newItems, oldItems) {
            //     newItems.forEach((newItem, index) => {
            //         const oldItem = oldItems[index];
            //         if (newItem.configQty !== oldItem.configQty) {
            //             console.log(`configQty changed for item ${newItem.itemNo}: ${oldItem.configQty} -> ${newItem.configQty}`);
            //         }
            //         if (newItem.extraQty !== oldItem.extraQty) {
            //             console.log(`extraQty changed for item ${newItem.itemNo}: ${oldItem.extraQty} -> ${newItem.extraQty}`);
            //         }
            //         console.log(`extraQty changed for item ${newItem.itemNo}: ${oldItem.extraQty} -> ${newItem.extraQty}`);
            //     });
            // },
            // deep: true
            handler(newItems) {
                newItems.forEach((item, index) => {
                // this.$watch(
                //     () => item.qty,
                //     async (newVal, oldVal) => {
                //         if (newVal !== oldVal) {
                //             console.log(`configQty changed for item ${item.itemNo}: ${oldVal} -> ${newVal}`);
                //             var payload = {
                //                 facilityPriceLevel: this.facilityPriceLevel,
                //                 number: item.itemNo,
                //                 qty: newVal,
                //                 unit: 'ea'
                //             }

                //             let itemPricesFound = await this.searchItemPrices(payload);
                //             if(itemPricesFound && itemPricesFound.length > 0){
                //                 item.unitPrice = itemPricesFound[0].uofmPrice
                //                 this.updateItemTotals(item)
                //             }
                //         }
                //     }
                // );
                    this.$watch(
                        () => item.configQty,
                        async (newVal, oldVal) => {
                            if (newVal !== oldVal) {
                                // console.log(`configQty changed for item ${item.itemNo}: ${oldVal} -> ${newVal}`);
                                //change qty
                                // item.qty = Number(item.configQty) + Number(item.extraQty)
                                // var payload = {
                                //                 facilityPriceLevel: this.facilityPriceLevel,
                                //                 number: item.itemNo,
                                //                 qty: item.qty,
                                //                 unit: 'ea'
                                //             }

                                // let itemPricesFound = await this.searchItemPrices(payload);
                                // this.calculateItemPriceAfterQtyChanged(item)
                            }
                        }
                    );
        //   this.$watch(
        //     () => item.extraQty,
        //     (newVal, oldVal) => {
        //       if (newVal !== oldVal) {
        //         console.log(`extraQty changed for item ${item.itemNo}: ${oldVal} -> ${newVal}`);
        //       }
        //     }
        //   );
        });
      },
      deep: true,
      immediate: true
        },
        'dmsConfigData.distanceEquipToRoom.value': function(newValue, oldValue) {
            clearTimeout(this.distanceDebounceTimer);
            this.distanceDebounceTimer = setTimeout(() => {
                console.log('Distance value changed after 1.5 seconds:', newValue)
                if (!newValue) {
                    // this.cur/rentStep = 1
                } else {
                    this.currentStep = this.currentStep > 1? this.currentStep : 2
                }
                this.recalculateAllItems()
            }, 1500); 
        },
        // 'dmsConfigData.detergentContainerQty.value': function(newValue, oldValue) {
        //     console.log('Container quantity changed:', newValue);
        //     if(!newValue) {
        //         this.updateItemQtyByitemNo('LUS-G6X4LG6', 0)
        //         this.updateItemQtyByitemNo('LUS-C6LG6', 0)
        //     } else if (newValue < 2) {
        //         this.updateItemQtyByitemNo('LUS-G6X4LG6', 2)
        //         this.updateItemQtyByitemNo('LUS-C6LG6', 2)
                
        //     } else {
        //         this.updateItemQtyByitemNo('LUS-G6X4LG6', 6)
        //         this.updateItemQtyByitemNo('LUS-C6LG6', 6)
                
        //     }
        // },
        'dmsConfigData.detergentContainerQty.value': function(newValue, oldValue) {
            clearTimeout(this.distanceDebounceTimer);
            this.distanceDebounceTimer = setTimeout(() => {
                // console.log('dmsConfigData.detergentContainerQty.value:', newValue)
                if (!newValue) {
                    // this.currentStep = this.currentStep < 2? this.currentStep : 2
                } else {
                    this.currentStep = this.currentStep > 2? this.currentStep : 3
                }
                this.recalculateAllItems()
            }, 1500); 
        },
        'dmsConfigData.containerSize.value': function(newValue, oldValue) {
            // clearTimeout(this.distanceDebounceTimer);
            // this.distanceDebounceTimer = setTimeout(() => {
            // }, 1500); 
            // console.log('dmsConfigData.containerSize.value:', newValue)
            if (!newValue) {
                // this.currentStep = this.currentStep < 3? this.currentStep : 3
            } else {
                this.currentStep = this.currentStep > 3? this.currentStep : 4
            }
            this.recalculateAllItems()
        },
        'dmsConfigData.jobSize.value': function(newValue, oldValue) {
            // clearTimeout(this.distanceDebounceTimer);
            // this.distanceDebounceTimer = setTimeout(() => {
            // }, 1500); 
            // console.log('dmsConfigData.jobSize.value:', newValue)
            if (!newValue) {
                // this.currentStep = this.currentStep < 3? this.currentStep : 3
            } else {
                this.currentStep = this.currentStep > 4? this.currentStep : 5
            }
            this.recalculateAllItems()
        },
        'dmsConfigData.pmContract.value': function(newValue, oldValue) {
            // clearTimeout(this.distanceDebounceTimer);
            // this.distanceDebounceTimer = setTimeout(() => {
            // }, 1500); 
            // console.log('dmsConfigData.jobSize.value:', newValue)
            if (!newValue) {
                // this.currentStep = this.currentStep < 3? this.currentStep : 3
            } else {
                this.currentStep = this.currentStep > 5? this.currentStep : 6
            }
            this.recalculateAllItems()
        },
        'quoteId': function(newValue, oldValue) {
            this.getDmsItems()
        },
    },
    created() {
        
    }
  };

  </script>
  
  <style scoped>
  .question-order {
    font-size: 18px;
    font-weight: bold;
    text-align: center;
  }
  .question-text {
    padding-right: 16px;
  }
  .question-info {
    font-size: 14px;
    color: #666;
    
  }
  </style>